import { useEffect, useState } from "react";
import Axios from 'axios';

const ProfilePic=({profileData,webToken,profilePic,customSize,picChange,profileBtn})=>{
    const [imgFile, setImgFile] = useState(null);

    const base64ToBlob=(base64String, contentType = '')=> {
        const byteCharacters = atob(base64String);
        const byteArrays = [];
    
        for (let i = 0; i < byteCharacters.length; i++) {
            byteArrays.push(byteCharacters.charCodeAt(i));
        }
    
        const byteArray = new Uint8Array(byteArrays);
        return new Blob([byteArray], { type: contentType });
    }

    const showProfilePic=(encodedData)=>{
        if(encodedData!=='not-provided')
        {
            if(encodedData.includes("https://"))
            {
                setImgFile(encodedData);
            }
            else
            {
                const base64Data=encodedData.substr(encodedData.indexOf(',') + 1);
                const contentType=encodedData.substr(0,encodedData.indexOf(';')+1);
                const blob = base64ToBlob(base64Data,contentType);
                setImgFile(URL.createObjectURL(blob));
            }
        }
    }

    const getPofilePic=()=>{
        Axios.post(`${alimAPIBaseURI}rpc/get_user_profile_pic`, {},{headers: {"Content-Type": "application/json","Authorization":`bearer ${webToken}`}}).then((data)=>{
            if(data.data!==null&&data.data!=="no-profile-pic")
            {
                showProfilePic(data.data);
                localStorage.alimProfilePic=data.data;
                if(remProfilePicEvent)
                {
                    document.dispatchEvent(remProfilePicEvent);
                }
            }
        }).catch((error)=>{
            console.log(error);
        });
    }

    const checkProfilePic=()=>{
        if(profilePic===undefined||profilePic==="load-profile")
        {
            const userProfilePic=localStorage.alimProfilePic;
            if(userProfilePic===undefined||userProfilePic===null)
            {
                getPofilePic();
            }
            else
            {
                showProfilePic(userProfilePic);
            }
        }
        else if(profilePic!==null&&profilePic!=="no-profile-pic")
        {
            showProfilePic(profilePic);
        }
    }

    useEffect(()=>{
        checkProfilePic();
    },[profilePic,picChange]);

    useEffect(()=>{
        checkProfilePic();
    },[]);

    if(imgFile!==null)
    {
        return(
            <img src={imgFile} alt='User profile image' className={`rounded-full max-w-[none] object-cover alim-body-color-style ${customSize?customSize:"w-[50px] h-[50px]"}`} loading="lazy"/>
        );
    }
    else
    {
        return(
            <div className={`overflow-hidden rounded-full alim-body-color-style relative ${customSize?customSize:"w-[50px] h-[50px]"}`}>
                <img src='/images/comments/anon-user.svg' alt='User profile image' className={`rounded-full absolute -bottom-0.5 left-0 right-0 max-w-[none] object-cover w-[90%] h-[90%] mx-auto`} loading="lazy"/>
            </div>
            
        );
    }
}

export default ProfilePic;